<template>
  <div class="stock-kline-view">
    <StockKLine :stock-code.sync="stockCode" />
  </div>
</template>

<script>
import StockKLine from '@/components/kline/StockKLine.vue'

export default {
  name: 'StockKLineView',
  components: {
    StockKLine
  },
  data() {
    return {
      stockCode: 'sz.002602'
    }
  },
  created() {
    if (this.$route.query.code) {
      this.stockCode = this.$route.query.code
    }
  }
}
</script>

<style scoped>
.stock-kline-view {
  padding: 20px;
  flex: 1;
}
</style>
